import { Context, ReactiveScopeControl } from '@ibyar/expressions';


export class ReactiveSignalScopeControl<T extends Context> extends ReactiveScopeControl<T> {

}

